/**
 * Enum values will typically be capitlised and separated by underscores.
 * For classnames, we want lowercase alphanumeric characters where all other
 * characters are replaced with a hyphen
 */
export default function enumToClassName(value: string): string {
    return value.toLowerCase().replaceAll(/[^A-Za-z0-9]+/g, '-');
}
